<div class="containerView">
<section class="bg-gray-50 max-w-[1300px] pr-6 pb-7 mx-auto 2xl:mx-0">

  <div class="flex items-center 2xl:justify-between mb-14">
    <h1 class="text-3xl w-[200px] font-bold text-dimot-3">Il mio profilo</h1>
    <button
      (click)="logout()"
      type="button"
      class="ml-auto cursor-pointer text-white bg-red-700 hover:bg-red-500 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex items-center"
    >
      Esci
      <svg
        class="w-3.5 h-3.5 ms-2"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 10"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M1 5h12m0 0L9 1m4 4L9 9"
        />
      </svg>
    </button>
  </div>


  <div
    class="flex flex-col xl:flex-row gap-10 mb-16 w-full mx-auto"
  >

    <div
      class="w-full px-15 pt-5 border border-gray-200 bg-white rounded-lg shadow-md h-[320px] xl:w-3/5"
    >
      <div class="mb-8 border-b border-gray-300 pb-5">
        <div class="flex items-center justify-between">
          <h2 class="text-xl xl:text-lg font-bold text-dimot-3">
            Informazioni Personali
          </h2>

          <button
            (click)="openEditProfile()"
            aria-label="Modifica profilo"
            class="cursor-pointer hidden"
          >
            <img
              src="./assets/img/Icons/pen-outline.png"
              width="30"
              height="30"
              alt="edit"
            />
          </button>
        </div>
      </div>

      <div class="flex flex-wrap w-full">

        <div class="flex items-center gap-5 w-[60%] mb-4">

          <div class="profile-picture flex justify-center items-center">
            <div class="user-initials text-center">
              {{ userInitials }}
            </div>
          </div>

          <div>
            <h3 class="text-lg xl:text-base font-semibold text-gray-800">
              {{ fullName | titlecase }}
            </h3>
            <span
              class="bg-green-100 text-green-800 text-xs xl:text-[0.65rem] font-semibold px-2 py-0.5 rounded"
            >
              {{ role }}
            </span>
          </div>
        </div>


        <div class="w-[40%] mb-4 mt-2">
          <p class="text-sm text-gray-600 mb-1">Paese:</p>
          <p class="text-sm text-gray-400">Italy</p>
        </div>

        <div class="w-[60%] mb-4 mt-6">
          <p class="text-sm text-gray-600 mb-2">E-mail:</p>
          <p class="text-sm text-gray-400 break-words mb-2">
            {{ userEmail }}
          </p>
          <span
            class="hidden flex-row text-[0.85rem] xl:text-[0.75rem] max-w-[170px] text-blue-600 cursor-not-allowed"
            >Cambia la password
            <img
              src="./assets/img/Icons/carbon_password.svg"
              class="w-3.5 ml-2"
          /></span>
        </div>

        <div class="w-[40%] mb-4 mt-6 flex flex-col" *ngIf="roleCode">
          <span class="text-sm text-gray-600 mb-1">Regioni:</span>
          <span class="text-sm text-gray-400">
            Accesso a
            <span class="text-gray-400">
              {{
                roleCode === "USERS"
                  ? regions.join(", ")
                  : "tutte le regioni"
              }}
            </span>
        
          </span>
        </div>
      </div>
    </div>


    <div
      class="w-full px-15 sm:px-[60px] xl:px-6 2xl:px-8 pt-5 border border-gray-200 bg-white rounded-lg shadow-md h-[220px] xl:h-[320px] xl:w-2/5"
    >
      <div class="mb-8 border-b border-gray-300 pb-5">
        <div class="flex items-center justify-between">
          <h2 class="text-xl xl:text-lg font-bold text-dimot-3">
            Informazioni Aziendali
          </h2>
        </div>
      </div>

    
      <div class="flex flex-row xl:flex-col">
        <div class="flex items-center mb-8">
    
          <img
            src="./assets/img/Icons/Logo_Dimot.png"
            alt="Logo azienda"
            class="w-16 h-16"
          />
          <h3 class="text-lg xl:text-base font-semibold text-gray-800 ms-5">
            Dimot MA
          </h3>
        </div>

        
        <div
          class="text-[1rem] xl:text-sm text-gray-700 flex justify-center pl-5 xl:pl-0"
        >
          <div class="w-full">
            <p class="font-medium text-gray-600 mb-3">Indirizzo:</p>
          
            <p class="text-gray-400">
              Lungotevere De’ Cenci 10, CAP 00186, ROMA (RM)
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div>
    <div
      class="mx-auto bg-white border border-gray-300 shadow-md sm:rounded-lg overflow-hidden w-full xl:max-w-full"
    >
      <div
        class="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 p-4"
      >
        <div class="w-full md:w-1/2">
          <h1 class="text-xl pl-3 text-dimot-1 pt-3 pb-5">Il mio Team</h1>
        </div>
        <div
          class="w-full md:w-auto flex flex-col md:flex-row space-y-2 md:space-y-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0"
        >
          
          <form class="items-center hidden">
            <label for="simple-search" class="sr-only"></label>
            <div class="relative w-full">
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
              >
                <svg
                  aria-hidden="true"
                  class="w-5 h-5 text-gray-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="text"
                id="simple-search"
                name="searchInput"
                placeholder="Cerca"
                class="pl-12 border border-gray-300 rounded-lg focus:border-gray-600 focus:ring-1 focus:ring-gray-500 transition-all duration-200"
                [(ngModel)]="searchText"
                (ngModelChange)="searchTeam()"
              />
            </div>
          </form>
        </div>
      </div>
      <div class="overflow-x-auto relative">
        <div
          class="min-h-[280px] max-h-[500px] absolute inset-0 z-10 bg-white/30 backdrop-blur-xs flex items-center justify-center"
        >
          <span class="text-gray-800 font-semibold text-lg"
            >Prossimamente disponibile</span
          >
        </div>
        <div class="min-h-[280px] max-h-[500px] overflow-y-auto">
          <table class="w-full text-sm text-left text-gray-500">
            <thead
              class="text-xs text-gray-700 uppercase bg-gray-50 border-b border-gray-200"
            >
              <tr>
                <th scope="col" class="px-8 py-3">UTENTE</th>
                <th scope="col" class="px-4 py-3">RUOLO</th>
                <th scope="col" class="px-4 py-3">REGIONI</th>
                <th scope="col" class="px-4 py-3">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="border-b border-gray-100"
                *ngFor="let user of filteredTeam"
              >
                <td class="px-8 py-3 text-blue-950">{{ user.name }}</td>
                <td class="px-4 py-3">{{ user.role }}</td>
                <td class="px-4 py-3">
                  Accesso a
                  <span *ngFor="let regione of user.regions; let last = last">
                    {{ regione }}<span *ngIf="!last">, </span>
                  </span>
                </td>
                <td class="pr-12 py-3 flex items-center justify-end">
                  <button class="cursor-pointer" (click)="openEditProfile()">
                    <svg
                      class="cursor-pointer"
                      fill="#141e58"
                      width="16px"
                      height="16px"
                      viewBox="0 0 1920 1920"
                      xmlns="http://www.w3.org/2000/svg"
                      transform="matrix(-1, 0, 0, 1, 0, 0)"
                    >
                      <path
                        d="M277.974 49.076c65.267-65.379 171.733-65.49 237.448 0l232.186 232.187 1055.697 1055.809L1919.958 1920l-582.928-116.653-950.128-950.015 79.15-79.15 801.792 801.68 307.977-307.976-907.362-907.474L281.22 747.65 49.034 515.464c-65.379-65.603-65.379-172.069 0-237.448Zm1376.996 1297.96-307.977 307.976 45.117 45.116 384.999 77.023-77.023-385-45.116-45.116ZM675.355 596.258l692.304 692.304-79.149 79.15-692.304-692.305 79.149-79.15ZM396.642 111.88c-14.33 0-28.547 5.374-39.519 16.345l-228.94 228.94c-21.718 21.718-21.718 57.318 0 79.149l153.038 153.037 308.089-308.09-153.037-153.036c-10.972-10.971-25.301-16.345-39.63-16.345Z"
                        fill-rule="evenodd"
                      />
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>


<div *ngIf="isModalEditProfile">
  <app-edit-profile
    (isEditModalOpen)="handleModalEditProfile($event)"
  ></app-edit-profile>
</div>

</div> 